import { Box, Checkbox, Grid, styled } from '@mui/material';
import {
  FIXED_FOOTER_HEIGHT,
  STEPPER_HEADER_HEIGHT_WITHOUT_TITLE,
} from 'src/constants';

export const StepContentWrapper = styled(Box)(
  ({ theme }) => `
  border-top: 1px solid ${theme.palette.secondary.lightest};
  height: calc(100vh - ${STEPPER_HEADER_HEIGHT_WITHOUT_TITLE}px - ${FIXED_FOOTER_HEIGHT}px - 20px);
  overflow: hidden;
  margin-left: -30px;
  margin-right: -30px;
  @media screen and (max-width: 1300px), (max-height: 700) {
    overflow: auto;
  }
`,
);

export const StepContentContainer = styled(Grid)`
  height: 100%;
  margin-top: 0;
  padding: 0px 20px 0px 20px;
`;

export const ScheduleComponentLayoutWrapper = styled(Grid)`
  height: 100%;
`;

export const StyledRowsCheckbox = styled(Checkbox)`
  margin-right: 16px;
  padding-left: 8px;
`;

export const StyledHeaderCheckbox = styled(Checkbox)`
  margin-right: 16px;
`;
